module.exports = __webpack_public_path__ + "static/media/logo.2d11e1c0.png";